<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-4 rounded-lg elevation-2">

            <!-- Search + Add Button -->
            <v-row class="align-center mb-4">
              <v-col md="4">
                <v-text-field
                  v-model="search"
                  label="Search BOM"
                  prepend-inner-icon="mdi-magnify"
                  variant="outlined"
                  density="comfortable"
                  clearable
                  hide-details
                />
              </v-col>

              <v-col md="3" offset-md="5" class="text-right">
                <v-btn
                    color="primary"
                    variant="tonal"
                    prepend-icon="mdi-plus"
                    @click="goCreate"
                    rounded="xl"
                >
                    Add BOM
                </v-btn>
              </v-col>
            </v-row>

            <!-- Main Table -->
            <v-data-table
              :headers="headers"
              :items="bomList"
              :search="search"
              :loading="loading"
              density="comfortable"
              item-key="id"
              class="elevation-1 rounded-lg"
              show-expand
            >

              <!-- Serial -->
              <template v-slot:item.index="{ index }">
                <strong>{{ index + 1 }}</strong>
              </template>

              <!-- Style -->
              <template v-slot:item.style="{ item }">
                {{ item.style?.code }}
              </template>

              <!-- Status -->
              <template v-slot:item.status="{ item }">
                <v-chip
                  size="small"
                  :color="item.status ? 'green' : 'red'"
                  text-color="white"
                >
                  {{ item.status ? "Active" : "Inactive" }}
                </v-chip>
              </template>

              <!-- Actions -->
              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon="mdi-pencil"
                  color="primary"
                  variant="text"
                  @click="goEdit(item)"
                />
              </template>

              <!-- Smooth Accordion Expanded Row -->
              <template v-slot:expanded-row="{ columns, item }">
                <td :colspan="columns.length" class="pa-0">

                  <v-expand-transition>
                    <div class="accordion-box">

                      <v-card flat class="pa-4 rounded-xl elevation-1">

                        <!-- FABRIC -->
                        <h4 class="text-h6 font-weight-bold mb-3 text-center">
                          Fabric List
                        </h4>

                        <v-table class="rounded-lg elevation-1 mb-6" density="compact">
                          <thead>
                            <tr class="bg-grey-lighten-3">
                              <th class="text-left" style="width:10%">#</th>
                              <th class="text-left" style="width:35%">Fabric Type</th>
                              <th class="text-left" style="width:30%">Consumption</th>
                              <th class="text-left" style="width:25%">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(fab, i) in item.fabrics" :key="fab.id">
                              <td>{{ i + 1 }}</td>
                              <td>{{ fab.fabric_type }}</td>
                              <td>{{ fab.consumption }}</td>
                              <td>
                                <v-chip
                                  size="small"
                                  :color="fab.status ? 'green' : 'red'"
                                  text-color="white"
                                >
                                  {{ fab.status ? "Active" : "Inactive" }}
                                </v-chip>
                              </td>
                            </tr>

                            <tr v-if="item.fabrics.length === 0">
                              <td colspan="4" class="text-center py-2">No Fabric Found</td>
                            </tr>
                          </tbody>
                        </v-table>


                        <!-- TRIM -->
                        <h4 class="text-h6 font-weight-bold mb-3 text-center">
                          Trim List
                        </h4>

                        <v-table class="rounded-lg elevation-1" density="compact">
                          <thead>
                            <tr class="bg-grey-lighten-3">
                              <th class="text-left" style="width:10%">#</th>
                              <th class="text-left" style="width:35%">Trim Name</th>
                              <th class="text-left" style="width:30%">Consumption</th>
                              <th class="text-left" style="width:25%">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(tr, j) in item.trims" :key="tr.id">
                              <td>{{ j + 1 }}</td>
                              <td>{{ tr.trim_name }}</td>
                              <td>{{ tr.consumption }}</td>
                              <td>
                                <v-chip
                                  size="small"
                                  :color="tr.status ? 'green' : 'red'"
                                  text-color="white"
                                >
                                  {{ tr.status ? "Active" : "Inactive" }}
                                </v-chip>
                              </td>
                            </tr>

                            <tr v-if="item.trims.length === 0">
                              <td colspan="4" class="text-center py-2">No Trim Found</td>
                            </tr>
                          </tbody>
                        </v-table>

                      </v-card>

                    </div>
                  </v-expand-transition>

                </td>
              </template>

            </v-data-table>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>


<script>
export default {
  data() {
    return {
      search: "",
      loading: false,

      headers: [
        { title: "#SL", key: "index", sortable: false },
        { title: "BOM Code", key: "code" },
        { title: "Style Code", key: "style" },
        { title: "Version", key: "version" },
        { title: "Status", key: "status", align: "center" },
        { title: "Actions", key: "actions", align: "center", sortable: false },
        { title: "", key: "data-table-expand" },
      ],
    };
  },

  computed: {
    bomList() {
      return this.$store.getters.getProductionBomList;
    },
  },

  methods: {
    loadList() {
      this.loading = true;
      this.$store.dispatch("getProductionBomList").finally(() => {
        this.loading = false;
      });
    },

    goCreate() {
      this.$router.push({ name: "bom-create" });
    },

    goEdit(item) {
      this.$router.push({ name: "bom-create", params: { id: item.id } });
    },
  },

  created() {
    this.loadList();
  },
};
</script>

<style scoped>
.text-right {
  text-align: right;
}

/* Smooth accordion container */
.accordion-box {
  margin: 10px 0;
  overflow: hidden;
  border-radius: 12px;
}
</style>
